var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50001 0.5C4.04184 0.50172 2.6439 1.08174 1.61282 2.11281C0.581741 3.14389 0.00172609 4.54184 5.85144e-06 6C-0.00174059 7.19161 0.387496 8.35089 1.10801 9.3C1.10801 9.3 1.25801 9.4975 1.28251 9.526L5.50001 14.5L9.7195 9.5235C9.7415 9.497 9.892 9.3 9.892 9.3L9.8925 9.2985C10.6127 8.34981 11.0017 7.19107 11 6C10.9983 4.54184 10.4183 3.14389 9.38719 2.11281C8.35611 1.08174 6.95817 0.50172 5.50001 0.5ZM5.50001 8C5.10444 8 4.71776 7.8827 4.38886 7.66294C4.05997 7.44318 3.80362 7.13082 3.65225 6.76537C3.50087 6.39991 3.46126 5.99778 3.53843 5.60982C3.61561 5.22186 3.80609 4.86549 4.08579 4.58579C4.3655 4.30608 4.72186 4.1156 5.10982 4.03843C5.49779 3.96126 5.89992 4.00087 6.26537 4.15224C6.63082 4.30362 6.94318 4.55996 7.16294 4.88886C7.38271 5.21776 7.50001 5.60444 7.50001 6C7.49934 6.53023 7.28842 7.03855 6.91349 7.41348C6.53856 7.78841 6.03024 7.99934 5.50001 8Z",
    fill: "#55BCB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/location-blue.76ad524ffb051dadd3f7d8edde20a0a5.svg";
export { ForwardRef as ReactComponent };